import moment from 'moment';
import React from 'react';
import { enumValue } from '~/util';

interface ReminderWarningIconProps {
    reminder: ReminderType;
}
export function ReminderWarningIcon({ reminder }: ReminderWarningIconProps) {
    if (
        reminder.timely_action &&
        reminder.status === enumValue(['task', 'status', 'Not Started'])
    ) {
        const now = moment();
        if (
            moment(reminder.timely_action.metadata.criticalNotificationDate).isSameOrBefore(
                now,
                'day'
            )
        )
            return (
                <i
                    title="This reminder requires immediate attention."
                    className="fa-solid fa-exclamation-circle text-danger ms-1"
                >
                    <span className="sr-only">This reminder requires immediate attention.</span>
                </i>
            );
        if (
            moment(reminder.timely_action.metadata.warningNotificationDate).isSameOrBefore(
                now,
                'day'
            )
        )
            return (
                <i
                    title="This reminder is approaching its due date."
                    className="fa-solid fa-exclamation-triangle text-warning ms-1"
                >
                    <span className="sr-only">This reminder is approaching its due date.</span>
                </i>
            );
    }

    return null;
}
